import React from "react";
import { useTheme } from "../../hooks/useTheme";

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  return (
    <div className="inline-flex items-center gap-2">
      <label className="text-xs text-gray-500 dark:text-gray-400">Theme</label>
      <select
        value={theme}
        onChange={(e) => setTheme(e.target.value)}
        className="rounded-lg border border-gray-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-sm px-2 py-1"
        title="Theme"
      >
        <option value="system">System</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </div>
  );
}
